export const getAdThumbnailStyles = () => ({
  root: {
    '& .fui-CardHeader__image': {
      padding: 6,
      background: '#F0F0F0',
      borderRadius: 4,
    },

    '& .fui-CardHeader__action': {
      display: 'flex',
    },

    '& .fui-Button': {
      border: 'none',
      marginLeft: 4,
    },
  },
  cardPreview: {
    width: 365,
    height: 236,
    background: '#F0F0F0',
    padding: 10,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',

    '& .cropped-image-view': {
      borderRadius: 5,
    },

    '& video': {
      borderRadius: 5,
      objectFit: 'cover',
    },
  },
  imageContainer: {
    overflow: 'hidden',
    borderRadius: 5,
    position: 'relative',
  },
  nativeAdImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  nativeAdImageForeground: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    top: 80,
    backgroundImage: 'linear-gradient(to bottom, transparent 0, black 100%)',
  },
  textOverlay: {
    height: 'fit-content !important',
    width: '90% !important',
    position: 'absolute',
    bottom: 20,
    left: 20,
    display: 'flex !important',
    flexDirection: 'column',
    color: 'white',

    '& .fui-Text': {
      marginBottom: 2,
    },
  },
  adLabel: {
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    border: '0.5px solid white',
    padding: '2px 4px',
    borderRadius: 3,
    marginRight: 4,
  },
  previewDescription: {
    textOverflow: 'ellipsis !important',
    width: 208,
    overflow: 'hidden !important',
    whiteSpace: 'nowrap !important',
  },
});

export const getAdsContainerStyles = () => ({
  menuButton: {
    height: 'fit-content',
    '& svg': {
      marginRight: 4,
      color: '#0078D4',
    },
  },
  menuContainer: {
    '& svg': {
      marginRight: 4,
    },
    '& .fui-MenuItem__content': {
      display: 'flex',
      minWidth: 157,
      padding: 5,
    },
  },
  toolbar: {
    margin: '17px 0',
  },
  radioGroup: {
    flexDirection: 'row !important',
  },
  radioOption: {
    padding: '6px 14px',
    borderRadius: 8,
    margin: '0 4px',
    border: '1px solid #E1DFDD',

    '& .fui-Radio__indicator': {
      display: 'none',
    },

    '& .fui-Label ': {
      padding: 0,
    },

    '&.selected': {
      border: '1px solid #0078D4',
    },
  },
  emptyViewContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',

    '& .empty-view-title': {
      fontWeight: 500,
      fontSize: 20,
      lineHeight: '24px',
      color: '#212121',
    },

    '& .empty-view-desc': {
      marginTop: 16,
      maxWidth: 350,
      fontWeight: 400,
      fontSize: 16,
      lineHeight: '24px',
      color: '#6E6E6E',
      textAlign: 'center',
    },
  },
});
